// eslint-disable-next-line


export const asyncRouterMap = [{
  path: '/',
  name: 'home',
  component: () => import(/* webpackChunkName: "user" */ '@/layouts/BasicLayout'),
  meta: { title: 'home.title' },
  children: []
}
]

/**
 * Basic routes
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import ('@/views/webpublic/dashboard/Homepage.vue')
  },
  {
    path: '/oneClickOpen',
    name: 'oneClickOpen',
    component: () => import ('@/views/webpublic/oneClickOpen/index.vue')
  },
  {
    path: '/user',
    component: () => import(/* webpackChunkName: "user" */ '@/layouts/UserLayout.vue'),
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'authChange',
        name: 'authChange',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/AuthChange')
      },
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
      },
      {
        path: 'googleAuthGuide',
        name: 'googleAuthGuide',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/GoogleAuthGuide')
      }
    ]
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  }

]
